export default __webpack_public_path__ + "static/ear_bg-2ac2e2c61039b3c35f7e18246145e5df.png";